// "New campaign" action. Navigates to the wizard at /campaigns/new.
// Gated by useCampaignPermissions — only renders for roles with canCreate.

import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SimpleButton } from '../../../../ui';
import { useCampaignPermissions } from '../../hooks/useCampaignPermissions';

const NewCampaignButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = useCampaignPermissions();

  if (!permissions.canCreate) return null;

  return (
    <SimpleButton variant='primary' startIcon='Add' onClick={() => navigate('/campaigns/new')}>
      {t('campaigns.new', 'New campaign')}
    </SimpleButton>
  );
};

export default NewCampaignButton;
